
import React from 'react'
import { useDataLayerValue } from '../../../Context_API/Data_Layer';
import './Body.css';
import Header from './Header/Header';
import SongRow from "./SongRow/SongRow";
import FavoriteIcon from "@material-ui/icons/Favorite";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";

function Body({spotify}) {

    const [{ discover_weekly }, dispatch] = useDataLayerValue();

    return (
      <div className="body">
        <Header spotify={spotify} />

        <div className="body_info">
          <img src={discover_weekly?.images[0].url} alt="Discover" />
          <div className="body_info_Text">
            <strong>PLAYLIST</strong>
            <h2>Discover Weekly</h2>
            <p>{discover_weekly?.description}</p>
          </div>
        </div>

        <div className="body_songs">
          <div className="body_icons">
            <PlayCircleFilledIcon className="body_shuffle"/>
            <FavoriteIcon fontSize="large"/>
            <MoreHorizIcon />
          </div>

          {/* List of Songs */}
          {discover_weekly?.tracks.items.map(item => (
              <SongRow track={item.track}/>
          ))}

        </div>
      </div>
    );
}

export default Body;
